import React, { useMemo, useState } from 'react';
import { TEXT_COLOR } from '../theme';
import { Link as RouterLink, Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, CircularProgress, Link } from '@mui/material';
import useLogin from '../hooks/useLogin';
import { withLanguage } from './common/Texts';
import AuthShell from './auth/AuthShell';
import LabeledField from './auth/LabeledField';
import PasswordField from './auth/PasswordField';

export default function Login() {
    const { username, setUsername, password, setPassword, error, loading, loggedIn, submit } = useLogin();
    const [showPassword, setShowPassword] = useState(false);
    const language = useSelector((state) => state.user.language);
    const t = useMemo(() => withLanguage(language), [language]);

    if (loggedIn) return <Navigate to="/dashboard" replace />;

    const onSubmit = (e) => {
        e.preventDefault();
        if (!loading) submit();
    };

    return (
        <AuthShell onSubmit={onSubmit}>
            {error && <Alert severity="error" variant="outlined">{error}</Alert>}

            <LabeledField
                id="login-username"
                name="username"
                label={t('user')}
                autoFocus autoComplete="username"
                value={username} onChange={(e) => setUsername(e.target.value)}
            />

            <PasswordField
                id="login-password"
                name="password"
                label={t('password')}
                autoComplete="current-password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                show={showPassword} onToggleShow={() => setShowPassword((v) => !v)}
            />

            <Box sx={{ textAlign: 'center' }}>
                <Link
                    component={RouterLink} to="/reset-password-request"
                    variant="body2" underline="hover" sx={{ color: TEXT_COLOR }}
                >
                    {t('forgot_password')}
                </Link>
            </Box>

            <Button
                type="submit" fullWidth variant="contained" color="primary"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
            >
                {loading ? t('signing_in') : t('login')}
            </Button>
        </AuthShell>
    );
}
